/**
 * User Replacer View Extended
 */

define(function(require, exports, module) {
    'use strict';

    var user = require('user');
    var UserReplacerView = require('replacers/user/user.replacer.view');

    var USER_NAME_REPLACER = 'USER_NAME',
        USER_CURRENCY_REPLACER = 'USER_CURRENCY',
        USER_CELLPHONE_REPLACER = 'USER_CELLPHONE';

    module.exports = UserReplacerView.extend({
        renderUserCellphone: function() {
            if (user.get('userDetails')) {
                this.$el.html(user.get('userDetails').cellphone);
            }

            return this;
        },

        render: function() {
            UserReplacerView.prototype.render.apply(this, arguments);

            if (this.options.name === 'USER_CELLPHONE') {
                this.renderUserCellphone();
            }

            return this;
        }
    }, {
        nameOfReplacers: [
            USER_NAME_REPLACER,
            USER_CURRENCY_REPLACER,
            USER_CELLPHONE_REPLACER
        ]
    });
});
